<template>
  <dv-water-level-pond :config="config" style="width: 100%; height: 200px" />
</template>

<script>
export default {
  data() {
    return {
      config: {
        data: [66, 20, 10, 5],
        shape: "roundRect",
      },
    };
  },
};
</script>

<style>
</style>